import React, { FC } from 'react';
import { HeadFC, PageProps, graphql } from 'gatsby';
import View from '../../views/ThankYou';
import SEO from '../../components/Head';

import LayoutRaw from '../../components/Layout/Layout';

interface ContextType {
  locale: string;
  name: string;
}

const ThankYouPage: FC<PageProps<Queries.ThankYouPageQuery, ContextType>> = ({
  data,
}) => {
  return (
    <LayoutRaw>
      <View content={data} />
    </LayoutRaw>
  );
};

export const Head: HeadFC<Queries.ThankYouPageQuery, ContextType> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query ThankYouPage($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/thank-you/**" }) {
      childJson {
        ...Meta

        ...ThankYouCommon
        ...ThankYouPending
        ...ThankYouFailed
      }
    }
  }
`;

export default ThankYouPage;
